import { render } from "./RelatedAutoInsurance.vue?vue&type=template&id=61a38d32&scoped=true"
import script from "./RelatedAutoInsurance.vue?vue&type=script&lang=js"
export * from "./RelatedAutoInsurance.vue?vue&type=script&lang=js"

import "./RelatedAutoInsurance.vue?vue&type=style&index=0&id=61a38d32&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a38d32"]])

export default __exports__